import type { SharedApiV2 } from "@capstone/mock-api";
import { UserDetails } from "src/app/core/auth/user.service";
import { UUID } from "src/utils";
import { HelpAssistAssignableUser } from "./help-assist-assignable-user.model";

export class HelpAssistUser {
  private constructor(args: ClassProperties<HelpAssistUser>) {
    this.userId = args.userId;
    this.emailAddress = args.emailAddress;
    this.userDisplayName = args.userDisplayName;
    this.carrierId = args.carrierId;
  }

  public readonly carrierId: number | null;
  public readonly userId: UUID;
  public readonly emailAddress: string | null;
  public readonly userDisplayName: string;

  public static deserialize(
    apiModel: SharedApiV2.TicketUserDto,
  ): HelpAssistUser {
    return new HelpAssistUser({
      carrierId: apiModel.carrierId ?? null,
      emailAddress: apiModel.emailAddress ?? null,
      userDisplayName: apiModel.userDisplayName,
      userId: new UUID(apiModel.userId),
    });
  }

  public static deserializeList(
    items: readonly SharedApiV2.TicketUserDto[],
  ): HelpAssistUser[] {
    return items.map(HelpAssistUser.deserialize);
  }

  public static fromHelpAssistAssignableUser(
    user: HelpAssistAssignableUser,
  ): HelpAssistUser {
    return new HelpAssistUser({
      carrierId: null,
      emailAddress: user.email,
      userDisplayName: user.name,
      userId: user.userId,
    });
  }

  public static fromCurrentUser(currentUser: UserDetails): HelpAssistUser {
    return new HelpAssistUser({
      carrierId: null,
      emailAddress: currentUser.emailAddress,
      userDisplayName: currentUser.displayName,
      userId: currentUser.id,
    });
  }
}
